export const BLOG_THEME_TOKENS = {
    primary: '#1E63E9',
    text: '#0F172A',
    muted: '#64748B',
    bg: '#FFFFFF',
    surface: '#F8FAFC',
    border: '#E2E8F0',
    radius: 12,
    fontHeading: "'IBM Plex Sans Thai', system-ui, sans-serif",
    fontBody: "'IBM Plex Sans Thai', system-ui, sans-serif",
    maxWidth: 1200,
    stickyHeader: true,
    sidebarPosition: 'right',
    showBranding: true,
};
export const BLOG_THEMES = [
    {
        code: 'magazine', name: 'Magazine', phase1: true, minPlan: 'FREE', sortOrder: 1,
        description: 'Hero เด่น + grid 3 คอลัมน์ + sidebar หมวดหมู่ — เหมาะกับข่าวสารบริษัท',
        defaults: { sidebarPosition: 'right', maxWidth: 1200 },
    },
    {
        code: 'minimal', name: 'Minimal', phase1: true, minPlan: 'FREE', sortOrder: 2,
        description: 'คอลัมน์เดียว ตัวอักษรใหญ่ เน้นการอ่าน — สาย essay / thought leadership',
        defaults: { sidebarPosition: 'none', maxWidth: 760, radius: 4 },
    },
    {
        code: 'corporate', name: 'Corporate', phase1: true, minPlan: 'FREE', sortOrder: 3,
        description: 'โทนทางการ มี breadcrumb, sidebar CTA และฟอร์มติดต่อ — เหมาะกับ B2B',
        defaults: { sidebarPosition: 'right', primary: '#0B5FA5', radius: 6, maxWidth: 1140 },
    },
    {
        code: 'grid-cards', name: 'Grid Cards', phase1: true, minPlan: 'STARTER', sortOrder: 4,
        description: 'การ์ดเท่ากันหมด มี filter หมวดหมู่ด้านบน — เหมาะกับ portfolio / case study',
        defaults: { sidebarPosition: 'none', maxWidth: 1280 },
    },
    {
        code: 'timeline', name: 'Timeline', phase1: true, minPlan: 'STARTER', sortOrder: 5,
        description: 'เรียงตามเวลาแบบ feed — เหมาะกับข่าวประชาสัมพันธ์',
        defaults: { sidebarPosition: 'none', maxWidth: 880 },
    },
    {
        code: 'docs', name: 'Docs / Knowledge Base', phase1: true, minPlan: 'PRO', sortOrder: 6,
        description: 'Sidebar nav ซ้าย + ค้นหา + สารบัญด้านขวา — เหมาะกับคู่มือ / ศูนย์ช่วยเหลือ',
        defaults: { sidebarPosition: 'left', maxWidth: 1360, radius: 6 },
    },
];
export const PHASE1_BLOG_THEMES = BLOG_THEMES.filter((t) => t.phase1).map((t) => t.code);
export function blogTheme(code) {
    return BLOG_THEMES.find((t) => t.code === code);
}
export function defaultThemeConfig(code) {
    return { ...BLOG_THEME_TOKENS, ...(blogTheme(code)?.defaults ?? {}) };
}
//# sourceMappingURL=blog-themes.js.map